/* eslint-disable */
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { thickNfpPositionMintAbi } from "@/domains/abis/thick-v1-nfpm-abi"
import type { TokenAddress } from "@/domains/core"

import type { TransactionReceiptWaitOptions, TransactionReturnType } from "../types"
import { simulatedTransaction } from "../simulated-transaction"

type CreateThickNfpPositionProps = {
  account: Address
  chainId: number
  config: Config
  token0: TokenAddress
  token1: TokenAddress
  fee: bigint
  tickLower: bigint
  tickUpper: bigint
  amount0Desired: bigint
  amount1Desired: bigint
  amount0Min: bigint
  amount1Min: bigint
  deadline: number
  nfpManagerAddress: Address
  receiptWait?: TransactionReceiptWaitOptions
}

export const createThickNfpPositionPool = async ({
  account,
  chainId,
  config,
  token0,
  token1,
  fee,
  tickLower,
  tickUpper,
  amount0Desired,
  amount1Desired,
  amount0Min,
  amount1Min,
  deadline,
  nfpManagerAddress,
  receiptWait,
}: CreateThickNfpPositionProps): Promise<TransactionReturnType> => {
  try {
    console.log("minting", {
      tickLower,
      tickUpper,
      amount0Desired,
      amount1Desired,
      amount0Min,
      amount1Min,
      deadline,
      token0,
      token1,
      fee,
      nfpManagerAddress,
    })
    /*
      { internalType: "address", name: "token0", type: "address" },
      { internalType: "address", name: "token1", type: "address" },
      { internalType: "uint24", name: "fee", type: "uint24" },
      { internalType: "int24", name: "tickLower", type: "int24" },
      { internalType: "int24", name: "tickUpper", type: "int24" },
      { internalType: "uint256", name: "amount0Desired", type: "uint256" },
      { internalType: "uint256", name: "amount1Desired", type: "uint256" },
      { internalType: "uint256", name: "amount0Min", type: "uint256" },
      { internalType: "uint256", name: "amount1Min", type: "uint256" },
      { internalType: "address", name: "recipient", type: "address" },
      { internalType: "uint256", name: "deadline", type: "uint256" },
    */
    const params = {
      token0: token0.address,
      token1: token1.address,
      fee,
      tickLower,
      tickUpper,
      amount0Desired,
      amount1Desired,
      amount0Min,
      amount1Min,
      recipient: account,
      deadline,
    }

    const args = [
      token0.address,
      token1.address,
      fee,
      tickLower,
      tickUpper,
      amount0Desired,
      amount1Desired,
      amount0Min,
      amount1Min,
      account,
      deadline,
    ]

    console.log("args", args)

    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: thickNfpPositionMintAbi as Abi,
        account,
        address: nfpManagerAddress,
        args: [params],
        chainId,
        functionName: "mint",
      },
      receiptWait,
    })

    console.log("createThickNfpPositionPool->result", result)
    return result
  } catch (error: any) {
    console.error("createThickNfpPositionPool", error)
    return { success: false, error: error.message, code: error.code }
  }
}
